import axios from '../../../../api/axios';
import React,{useState,useEffect} from 'react';
import Swal from 'sweetalert2';
import { useAuth } from '../../../../ContextApp/AuthContext';
import { useNavigate } from 'react-router-dom';

function Insertion(){
    const navigate=useNavigate()
    const {user}=useAuth()
    const [sections,setSections]=useState([])
    const [section,setSection]=useState("")
    const [niveau,setNiveau]=useState("")
    const [lettre,setLettre]=useState("")
    const [nom,setNom]=useState("")
    const [data,setData]=useState([])
    const [isLoading,setIsLoading]=useState(false)
    const [classe_initiales,setClasses_initiales]=useState([])
    const record=sections.find(secti => Number(secti.idsection) === Number(section))   
    const datainitial=classe_initiales.filter(clas=>Number(clas.idsection)===Number(section) & Number(clas.niveau)===Number(niveau))
 
    const csrf=async()=>axios.get('sanctum/csrf-cookie')
    useEffect(()=>{            
        HandleRequest();
        Classes_initialesRequest();
    },[])
    useEffect(()=>{
        if(section!=="" && niveau!==""){
            setData(record)
            if(niveau==="1"){
                setNom(niveau+'ère '+data?.nom+'\\'+lettre)
               }
            else{
                setNom(niveau+'ème '+data?.nom+'\\'+lettre)
               }
        }
    },[section,niveau])
   const HandleChangeLettre=(e)=>{
    setLettre(e.target.value)
    setNom(niveau+'ème '+data?.nom+'\\'+e.target.value)
   }
   
    const HandleRequest=async()=>{
        await axios.get(`/api/sectionorg/${user?.ecole?.id}`).then((res)=>{
            setSections(res.data.items)
        }).catch((err)=>{
        })
    }
    const Classes_initialesRequest=async ()=>{
            await csrf();
            await axios.get('/api/classeinitiale').then(
                (res)=>{
                    setClasses_initiales(res.data.items)
                   
                }
            ).catch((err)=>{
                
            })
        }
    function confirmSave(e){
        e.preventDefault()
        if(nom !==""){
        Swal.fire({
            title:'Demande de confirmation',
            text:'Voulez-vous vraiment enregistrer ce cours ?',
            icon:'question',
            showCancelButton:true,
            showConfirmButton:true,
            confirmButtonText:'Confirmer',
        }).then((resultat)=>{
            if(resultat.isConfirmed){
                HandleSubmit()
            }
        })  
        }
        else{
            Swal.fire({
                title:'Erreur de soumission',
                text:'Veuillez d\'abord confirmer le nom du cours',
                icon:'warning'
            })
        }
    }
    const handleChangeSection=(e)=>{
        setSection(e.target.value)
        setData(record)
        setNiveau("")
       setLettre("")
       setNom("")
    }
    
    function handleChangeNiveau(e){
        setNiveau(e)
       setData(record)
    }
    
    const HandleSubmit=async (e)=>{
        setIsLoading(true)
        await csrf()
                await axios.post('/api/classe',{
                    classe:section,
                    nomclasse:nom,
                    niveau:niveau,
                    classe_initiale:datainitial[0]?.id,
                    lettre:lettre,
                    idsection:parseInt(section),
                    idecole:parseInt(user?.ecole?.id),
                    annee_scolaire:user?.programme_scolaire?.annee_scolaire,
                }).then((res)=>{
                    setIsLoading(false)
                    if(res.data.status_code===200){
                        setNom("")
                    setNiveau("")
                    setSection("")
                    setLettre("")
                        Swal.fire({
                            title:'Message de confirmation',
                            text:'La classe a été enregistrée avec succès',
                            icon:'success'
                            
                        })
                    }
                    else{
                        Swal.fire({
                            title:'Message d\'erreur',
                            text:res.data.status_message,
                            icon:'error'
                            
                        })
                    }
                     
                }).catch((err)=>{
                        document.getElementById("erreur").innerHTML=err
                        
                        
                })
    }
    return(
    <>

   { /*<Formulaire title="Formulaire d'inscription" handleBlurNiveau={handleBlurNiveau} handleBlurSection={handleBlurSection} confirmSave={confirmSave} setNom={setNom}   nom={nom}   Count={Count} setCount={setCount} HandleSubmit={HandleSubmit} niveau={niveau} setNiveau={setNiveau} section={section} setSection={setSection} sections={sections} setSections={setSections} handleChangeNiveau={handleChangeNiveau} handleChangeSection={handleChangeSection} >
        <div className="w-full md:w-1/1 px-3  md:mb-0">
        
        <div id="resultat" className="block text-red-700"></div>
        <div id="erreur" className="block text-red-500"></div>
    </div>
    </Formulaire>
    */
    }
 <div className="container py-5">
    <div className="row justify-content-center">
        <div className="col-12 col-lg-7">
            {/* Carte de formulaire avec ombre douce */}
            <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
                
                {/* En-tête avec dégradé moderne */}
                <div className="card-header bg-primary bg-gradient p-4 border-0">
                    <div className="d-flex align-items-center">
                        <div className="bg-white bg-opacity-25 rounded-circle p-3 me-3">
                            <i className="bi bi-plus-square-fill text-white fs-4"></i>
                        </div>
                        <div>
                            <h3 className="h4 text-white fw-bold mb-0">Ajout de la Classe</h3>
                            <p className="text-white text-opacity-75 small mb-0">Remplissez les détails pour créer une nouvelle salle</p>
                        </div>
                    </div>
                </div>

                <div className="card-body p-4 p-md-5 bg-light-subtle">
                    <form onSubmit={confirmSave}>
                        <div className="row g-4">
                            
                            {/* Section */}
                            <div className="col-md-12">
                                <label className="form-label fw-bold text-secondary px-1">Section d'étude</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-white border-end-0"><i className="bi bi-mortarboard text-primary"></i></span>
                                    <select name="section" className="form-select form-select-lg border-start-0 fs-6 shadow-none" onChange={handleChangeSection} value={section} required>
                                        <option value="" disabled>Choisir la section...</option>
                                        {sections.map((sect) => (
                                            <option value={sect.idsection} key={sect.idsection}>{sect.nom}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Niveau */}
                            <div className="col-md-6">
                                <label className="form-label fw-bold text-secondary px-1">Niveau</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-white border-end-0"><i className="bi bi-bar-chart-steps text-primary"></i></span>
                                    <select id="niveau" className="form-select form-select-lg border-start-0 fs-6 shadow-none" value={niveau} onChange={(e)=>handleChangeNiveau(e.target.value)} required>
                                        <option value="" disabled>Niveau...</option>
                                        {section === "1" ? (
                                            <>
                                                <option value="7">7ème</option>
                                                <option value="8">8ème</option>
                                            </>
                                        ) : (
                                            <>
                                                <option value="1">1ère</option>
                                                <option value="2">2ème</option>
                                                <option value="3">3ème</option>
                                                <option value="4">4ème</option>
                                            </>
                                        )}
                                    </select>
                                </div>
                            </div>

                            {/* Lettre */}
                            <div className="col-md-6">
                                <label className="form-label fw-bold text-secondary px-1">Local / Lettre</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-white border-end-0"><i className="bi bi-alphabet text-primary"></i></span>
                                    <select className="form-select form-select-lg border-start-0 fs-6 shadow-none" value={lettre} onChange={(e)=>HandleChangeLettre(e)} required>
                                        <option value="" disabled>Lettre...</option>
                                        {["A", "B", "C", "D", "E", "F", "G"].map(l => (
                                            <option key={l} value={l}>{l}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Nom de la classe (Lecture seule ou Auto-généré) */}
                            <div className="col-md-12">
                                <label className="form-label fw-bold text-secondary px-1">Désignation complète</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0"><i className="bi bi-pencil-square text-muted"></i></span>
                                    <input type="text" className="form-control form-control-lg border-start-0 fs-6 bg-light fw-bold text-primary shadow-none" value={nom} placeholder="S'affiche automatiquement" readOnly required />
                                </div>
                            </div>

                            {/* Bouton de soumission */}
                            <div className="col-12 pt-3">
                                <button className={`btn btn-primary btn-lg w-100 shadow rounded-pill py-3 fw-bold transition-all ${isLoading ? 'disabled' : ''}`} type="submit">
                                    {isLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Ajout en cours...
                                        </>
                                    ) : (
                                        <>
                                            <i className="bi bi-cloud-arrow-up-fill me-2"></i> Enregistrer la classe
                                        </>
                                    )}
                                </button>
                                <button type="button" onClick={() => navigate('/Classes')} className="btn btn-link w-100 text-muted mt-2 text-decoration-none small">
                                    Annuler et revenir
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

    </>
    )
}
export default Insertion